'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const TimeSelectWrapper = styled.div<{
  $hasError?: boolean;
  $isFocused?: boolean;
}>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  height: 2.625rem;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border: ${(props) =>
    props.$hasError
      ? `1px solid ${props.theme.colors.statusError}`
      : props.$isFocused
        ? `1px solid ${props.theme.colors.typographyBodyLight}`
        : 'none'};
  border-radius: ${Spacers.XS}rem;
`;

export const IconWrapper = styled.div<{ $isFocused?: boolean }>`
  position: absolute;
  top: 50%;
  left: ${Spacers.BASE}rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${(props) =>
    props.$isFocused
      ? props.theme.colors.typographyHeadersLight
      : props.theme.colors.typographyBodyLight};
`;

export const SelectField = styled.select<{
  $hasIcon?: boolean;
  $hasError?: boolean;
  $isFocused?: boolean;
}>`
  appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
  background: transparent;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
  font-family: inherit;
  color: ${(props) =>
    props.$hasError
      ? props.theme.colors.statusError
      : props.$isFocused
        ? props.theme.colors.typographyHeadersLight
        : props.theme.colors.typographyBodyLight};
  cursor: pointer;
  padding: 0;
  padding-left: ${(props) => (props.$hasIcon ? `${Spacers.XL}rem` : '0.125rem')};
  width: ${(props) => (props.$hasIcon ? '4.25rem' : '2rem')};

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Colon = styled.span<{
  $hasError?: boolean;
  $isFocused?: boolean;
}>`
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: 1;
  color: ${(props) =>
    props.$hasError
      ? props.theme.colors.statusError
      : props.$isFocused
        ? props.theme.colors.typographyHeadersLight
        : props.theme.colors.typographyBodyLight};
  user-select: none;
  flex-shrink: 0;
`;
